import { Injectable } from '@angular/core';

type TaskFn = () => void;

export enum TaskPriority {
  High,
  Normal,
  Low,
}

@Injectable({ providedIn: 'root' })
export class TaskScheduler {
  private macrotaskId: number | null = null;
  private macrotaskQueue: TaskFn[][] = [[], [], []];

  public scheduleMacrotask(priority: TaskPriority, task: TaskFn): void {
    this.macrotaskQueue[priority].push(task);

    if (!this.macrotaskId) {
      this.createMacroTask();
    }
  }

  private createMacroTask() {
    this.macrotaskId = requestAnimationFrame(() => {
      const result = this.processQueue();
      if (result) {
        this.createMacroTask();
      } else {
        this.macrotaskId = null;
      }
    });
  }

  private getQueue(): TaskFn[] | null {
    if (this.macrotaskQueue[TaskPriority.High].length) {
      return this.macrotaskQueue[TaskPriority.High];
    } else if (this.macrotaskQueue[TaskPriority.Normal].length) {
      return this.macrotaskQueue[TaskPriority.Normal];
    } else if (this.macrotaskQueue[TaskPriority.Low].length) {
      return this.macrotaskQueue[TaskPriority.Low];
    }

    return null;
  }

  private processQueue(): boolean {
    const queue = this.getQueue();
    if (!queue) return false;

    const startTime = performance.now();
    while (queue.length) {
      const task = queue.shift()!;
      task();
      if (performance.now() - startTime > 17) return true;
    }

    return true;
  }
}
